var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CLink',{staticClass:"btn-dribbble btn-sm btn mb-2 float-right",on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.$t('back'))+" "),_c('FaIcon',{attrs:{"icon":"chevron-left"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }